import { render, staticRenderFns } from "./hero-item.vue?vue&type=template&id=00061af0&scoped=true"
import script from "./hero-item.vue?vue&type=script&lang=js"
export * from "./hero-item.vue?vue&type=script&lang=js"
import style0 from "./hero-item.vue?vue&type=style&index=0&id=00061af0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00061af0",
  null
  
)

export default component.exports